import { MailRibbonControlId, FormatControlId, ActionControlId } from 'owa-ribbon-ids';
import type { RibbonControlId } from 'owa-ribbon-ids';

/**
 * This file contains the controls that have special cases when scaling (both initial scaling and
 * regular scaling)
 */

/**
 * Add controls here that should never display their labels
 */
export const controlsWithoutLabels: RibbonControlId[] = [
    FormatControlId.Bold,
    FormatControlId.Italic,
    FormatControlId.Underline,
    FormatControlId.StrikeThrough,
    FormatControlId.Bullets,
    FormatControlId.Numbering,
    FormatControlId.Indent,
    FormatControlId.Outdent,
    FormatControlId.UndoRedo,
    FormatControlId.AlignLeft,
    FormatControlId.AlignCenter,
    FormatControlId.AlignRight,
    FormatControlId.Subscript,
    FormatControlId.Superscript,
    FormatControlId.LeftToRight,
    FormatControlId.RightToLeft,
    FormatControlId.Quote,
    FormatControlId.ChangeCase,
    FormatControlId.FontColorPicker,
    FormatControlId.FontBackColorPicker,
    FormatControlId.FontNamePicker,
    FormatControlId.FontSizePicker,
    FormatControlId.FormatPainter,
    FormatControlId.RemoveFormat,
    FormatControlId.PasteCutCopy,
    MailRibbonControlId.BasicTextOverFlow,
    MailRibbonControlId.AttachFile,
    MailRibbonControlId.ShowLinkDialog,
    MailRibbonControlId.AttachSig,
    ActionControlId.GetAddIns,
    ActionControlId.Fluid,
    ActionControlId.SetImportance,
    ActionControlId.Sensitivity,
    MailRibbonControlId.Save,
];

/**
 * Add the controls here that should NOT drop their labels when they scale.
 * Note: These controls are ones that start off with labels. For controls that never
 * have labels, please place in controlsWithoutLabels section
 */
export const controlsDontDropLabels: RibbonControlId[] = [];

/**
 * Add the controls here that should NOT move to the overflow
 * menu when scaling
 */
export const controlsDontMoveToOverflow: RibbonControlId[] = [];
